

import { Mail } from "lucide-react";

export const ContactForm = () => {
  return (
    <section className="py-20 px-4 bg-white" id="contact">
      <div className="max-w-xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-12 text-foreground">Contact Us</h2>

        <p className="text-lg text-muted-foreground mb-12">
          Get in touch to learn how our solutions can transform your earbuds
        </p>
        
        <div className="fade-in">
          <div className="inline-flex items-center justify-center p-4 bg-[#A4CBA6]/10 rounded-lg border border-[#A4CBA6]/30 hover:border-[#ffa05d]/50 transition-all duration-300 hover:shadow-lg">
            <Mail className="h-5 w-5 text-[#ffa05d] mr-2" />
            <a 
              href="mailto:contact@auryx.ai" 
              className="text-base font-medium text-[#ffa05d] hover:text-[#ffa05d]/80 transition-colors"
            >
              contact@auryx.ai
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
